import React, { useState, useEffect } from 'react'
import styles from './HomeworkModal.module.css'
import Modal from 'react-responsive-modal'
import moment from 'moment'

const HomeworkModal = ({ data, onClose, formData, lessons }) => {

    const [tab, setTab] = useState(0)
    const [hwText, setHwText] = useState('')
    const [timeH, setTimeH] = useState(0)
    const [timeM, setTimeM] = useState(0)
    const [sendAsFile, setSendAsFile] = useState(false)

    useEffect(() => {
        if (data) {
            setHwText(data.hw_text_j || '')
            setTab(0)
        }
    }, [data])

    const subjectName = lessons?.find(l => l.cid == formData?.lesson)?.title || ''

    const handleSave = () => {
        // TODO: dispatch save homework
        onClose()
    }

    if (!data) return null

    return (
        <Modal
            open={!!data}
            onClose={onClose}
            closeOnOverlayClick={false}
            showCloseIcon={false}
            animationDuration={1}
            classNames={{ modal: styles.modal }}
        >
            {/* Заголовок */}
            <div className={styles.header}>
                <span className={styles.title}>Домашнее задание</span>
                <button className={styles.closeBtn} onClick={onClose}>×</button>
            </div>

            {/* Инфо */}
            <div className={styles.info}>
                <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Дата</span>
                    <span className={styles.infoValue}>{data.les_date ? moment(data.les_date).format('DD.MM') : '—'}</span>
                </div>
                <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Предмет</span>
                    <span className={styles.infoValue}>{subjectName}</span>
                </div>
                <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Взвод</span>
                    <span className={styles.infoValue}>{data.grpname || '—'}</span>
                </div>
            </div>

            {/* Вкладки */}
            <div className={styles.tabs}>
                <div className={tab === 0 ? styles.activeTab : styles.tab} onClick={() => setTab(0)}>Общее домашнее задание</div>
                <div className={tab === 1 ? styles.activeTab : styles.tab} onClick={() => setTab(1)}>Индивидуальное</div>
            </div>

            {/* Контент */}
            <div className={styles.content}>
                {tab === 0 ? (
                    <div className={styles.columns}>
                        {/* Текст */}
                        <div className={styles.col}>
                            <div className={styles.colTitle}>Текст</div>
                            <textarea
                                className={styles.textarea}
                                value={hwText}
                                onChange={e => setHwText(e.target.value)}
                            />
                        </div>
                        {/* Упражнения */}
                        <div className={styles.col}>
                            <div className={styles.colTitle}>Упражнения</div>
                            <div className={styles.fileList} />
                            <div className={styles.colBtns}>
                                <button className={styles.addBtn}>+ Добавить</button>
                                <button className={styles.delBtn}>✕ Удалить</button>
                            </div>
                        </div>
                        {/* Файлы */}
                        <div className={styles.col}>
                            <div className={styles.colTitle}>Файлы</div>
                            <div className={styles.fileActions}>
                                <button className={styles.actionBtn}>📄 Просмотр</button>
                                <button className={styles.actionBtn}>⬇ Получить</button>
                            </div>
                            <div className={styles.fileList} />
                            <div className={styles.colBtns}>
                                <button className={styles.addBtn}>+ Добавить</button>
                                <button className={styles.delBtn}>✕ Удалить</button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={styles.emptyTab}>Индивидуальные задания</div>
                )}
            </div>

            {/* Время */}
            <div className={styles.timeRow}>
                <span className={styles.timeLabel}>Время на выполнение</span>
                <input type="number" min={0} value={timeH} onChange={e => setTimeH(e.target.value)} className={styles.timeInput} />
                <span className={styles.timeUnit}>ч</span>
                <input type="number" min={0} value={timeM} onChange={e => setTimeM(e.target.value)} className={styles.timeInput} />
                <span className={styles.timeUnit}>мин</span>
                <label className={styles.checkLabel}>
                    <input type="checkbox" checked={sendAsFile} onChange={e => setSendAsFile(e.target.checked)} />
                    Прислать в виде файла преподавателю
                </label>
            </div>

            {/* Статус */}
            <div className={styles.statusBar}>
                <div>
                    <div>Кто создал: {data.teacher_fio || '—'}</div>
                    <div>Когда создал: {data.lessonfulldate || '—'}</div>
                </div>
                <div className={styles.footerBtns}>
                    <button className={styles.saveBtn} onClick={handleSave}>Сохранить</button>
                    <button className={styles.cancelBtn} onClick={onClose}>Отмена</button>
                </div>
            </div>
        </Modal>
    )
}

export default HomeworkModal
